import platformRoutes from './platform'
import userRoutes from './user'
import rootRoutes from './root'

export const routes = [
  ...rootRoutes,
  ...userRoutes,
  ...platformRoutes
]